<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="title || '样品批量上架'"
      :wrapperClosable="false"
      direction="rtl"
      size="1000px"
      @close="$refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main ref="main" :treeData="treeData" @close="close()" />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
